import { useState } from 'react';

import { TextField, Tooltip } from '@mui/material';

import { IQuestionnaireFormWidgetProps } from 'src/features/questionnaire/domain/types';

const TextAreaWidget: React.FC<IQuestionnaireFormWidgetProps> = ({
	question,
	onValueChange,
	isDisabled,
	error,
	helperText = 'This field is invalid',
}) => {
	const value = question.submitted_data?.value_text_area ?? '';

	const [textAreaValue, setTextAreaValue] = useState(value);

	const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setTextAreaValue(value);
		onValueChange(question, value, 'value_text_area');
	};

	const getToolTipTitle = () => {
		return (
			<span style={{ whiteSpace: 'pre-line' }}>
				Q: {question.text}
				{textAreaValue ? `\n\nAns: ${textAreaValue}` : ''}
			</span>
		);
	};

	return (
		<Tooltip title={getToolTipTitle()} arrow placement='left-start'>
			<TextField
				fullWidth
				label={question.text}
				required={question.is_required}
				multiline
				rows={4}
				value={textAreaValue}
				disabled={isDisabled}
				onChange={handleValueChange}
				error={error}
				helperText={error ? helperText : ''}
				sx={{
					'& input': {
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
						overflow: 'hidden',
					},
				}}
			/>
		</Tooltip>
	);
};

export default TextAreaWidget;
